import React from "react";
import { Typography } from "@mui/material";
import SpecsModelMultiAutocompleteField from "./components/editors/SpecsModelMultiAutocompleteField";
import { useSpecsModel } from "./SpecsModelContext";
import type { SpecsModel } from "./specsModel/SpecsModel";
import { useSpecsEditorContextValue } from "./useSpecsEditor";
import {
  getPositionStyleAssignments,
  getSelectedPositionForVersion,
  setStylePositionIdsForVersion,
} from "./positionEditorModel";

function getAssignedStyleLabels(
  model: SpecsModel,
  productVersion: string,
  selectedPositionId: string | null
) {
  const selectedPosition = getSelectedPositionForVersion(
    model,
    productVersion,
    selectedPositionId
  );

  return getPositionStyleAssignments(model, productVersion)
    .filter((assignment) =>
      selectedPosition?.id
        ? assignment.positionIds.includes(selectedPosition.id)
        : false
    )
    .map((assignment) => assignment.label);
}

export default function SpecsPositionStyleAssignmentsSection() {
  const specsModel = useSpecsModel();
  const {
    editor: {
      identity: { productVersion },
    },
    selectedPositionId,
  } = useSpecsEditorContextValue();

  return (
    <>
      <Typography variant="subtitle2">Style Assignments</Typography>
      <SpecsModelMultiAutocompleteField
        label="Assigned Styles"
        errorWhenEmpty
        helperText=" "
        selector={(model) =>
          getAssignedStyleLabels(model, productVersion, selectedPositionId)
        }
        options={getPositionStyleAssignments(specsModel, productVersion).map(
          (assignment) => assignment.label
        )}
        placeholder="Select styles"
        setValue={(model, nextLabels) => {
          const selectedPosition = getSelectedPositionForVersion(
            model,
            productVersion,
            selectedPositionId
          );
          if (!selectedPosition) {
            return;
          }
          const selectedPositionIdValue = selectedPosition.id;
          if (!selectedPositionIdValue) {
            return;
          }
          getPositionStyleAssignments(model, productVersion).forEach(
            (assignment) => {
              const shouldInclude = nextLabels.includes(assignment.label);
              const nextPositionIds = shouldInclude
                ? Array.from(
                    new Set([
                      ...assignment.positionIds,
                      selectedPositionIdValue,
                    ])
                  )
                : assignment.positionIds.filter(
                    (positionId: string) =>
                      positionId !== selectedPositionIdValue
                  );
              setStylePositionIdsForVersion(
                model,
                productVersion,
                assignment.styleKey,
                nextPositionIds
              );
            }
          );
        }}
      />
    </>
  );
}
